var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-collapsible',{attrs:{"title":"Contact Forms"}},[_c('div',{staticClass:"card-body"},[_c('contact-form-list',{attrs:{"list":_vm.list},on:{"delete":function($event){return _vm.deleteSubmission($event)}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }